const ENDPOINT_SESSIONS_LIST = '/secure/services/sessions-list'
const ENDPOINT_SESSIONS_DELETE = '/secure/service/sessions/:sessionId'
const ENDPOINT_SESSION_FIND_PARTICIPANTS =
  '/secure/service-sessions/:sessionId/find-user-to-participate'
const ENDPOINT_SESSION_PARTICIPANTS =
  '/secure/service-session/:sessionId/participants'
const ENDPOINT_SESSION_ONLINE_STATUS =
  '/secure/service-session/:sessionId/online-status'
const ENDPOINT_PARTICIPANT =
  '/secure/service-session/participant/:participantId'
const ENDPOINT_MANUAL_PARTICIPATION =
  '/secure/service-sessions/:sessionId/manual-participation-student/:userId'
const ENDPOINT_DELETE_PARTICIPANT =
  '/secure/service-sessions/:sessionId/:userId'
const ENDPOINT_PARTICIPANT_PRESENT =
  '/secure/participants/:participantId/present'
const ENDPOINT_PARTICIPANT_ABSENT = '/secure/participants/:participantId/absent'
const ENDPOINT_PARTICIPANT_REFUND = '/secure/participants/:participantId/refund'
const ENDPOINT_PARTICIPANT_CONFIRM_PAYMENT =
  '/secure/participants/:participantId/confirm-payment'

export const state = () => ({
  currentUserSessionsToValidate: [],
  currentCenterSessionsToValidate: [],
  currentSessionToValidate: []
})

export const mutations = {
  setCurrentUserSessionsToValidate(state, payload) {
    state.currentUserSessionsToValidate = payload
  },
  setCurrentCenterSessionsToValidate(state, payload) {
    state.currentCenterSessionsToValidate = payload
  },
  setCurrentSessionToValidate(state, payload) {
    state.currentSessionToValidate = payload
  }
}

export const getters = {
  getCurrentUserSessionsToValidate(state) {
    return state.currentUserSessionsToValidate
  },
  getCurrentCenterSessionsToValidate(state) {
    return state.currentCenterSessionsToValidate
  },
  getCurrentSessionToValidate(state, payload) {
    return state.currentSessionToValidate
  }
}

export const actions = {
  async fetchCurrentUserSessionsToValidate({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_SESSIONS_LIST}?teacher=${payload.teacherId}&isOld=true&isValidated=false&page=${payload.page}&limit=${payload.limit}`
      )
      //      console.log(response)
      //      commit('setCurrentUserSessionsToValidate', response.data)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCurrentCenterSessionsToValidate({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_SESSIONS_LIST}?center=${payload.centerId}&isOld=true&isValidated=false&page=${payload.page}&limit=${payload.limit}`
      )
      //      console.log(response)
      //      commit('setCurrentCenterSessionsToValidate', response.data)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCurrentUserSessions({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_SESSIONS_LIST}?teacher=${payload.teacherId}&isOld=${payload.isOld}&page=${payload.page}&limit=${payload.limit}`
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCurrentCenterSessions({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        `${ENDPOINT_SESSIONS_LIST}?center=${payload.centerId}&isOld=${payload.isOld}&page=${payload.page}&limit=${payload.limit}`
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCurrentSessionToValidate({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SESSION_PARTICIPANTS.replace(':sessionId', payload)
      )
      //      console.log(response)
      commit('setCurrentSessionToValidate', response.data)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchSession({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SESSION_PARTICIPANTS.replace(':sessionId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchSessionOnlineStatus({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SESSION_ONLINE_STATUS.replace(':sessionId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deleteSession({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_SESSIONS_DELETE.replace(':sessionId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchParticipant({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_PARTICIPANT.replace(':participantId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchCenterParticipants({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_SESSION_FIND_PARTICIPANTS.replace(':sessionId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async manualAddParticipant({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_MANUAL_PARTICIPATION.replace(
          ':sessionId',
          payload.sessionId
        ).replace(':userId', payload.userId),
        payload.form
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deleteParticipant({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_DELETE_PARTICIPANT.replace(
          ':sessionId',
          payload.sessionId
        ).replace(':userId', payload.userId)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async markParticipantPresent({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_PARTICIPANT_PRESENT.replace(':participantId', payload),
        {}
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async markParticipantAbsent({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const refundPercent = payload.refundPercent
      const response = await this.$axios.post(
        ENDPOINT_PARTICIPANT_ABSENT.replace(
          ':participantId',
          payload.participantId
        ),
        { refundPercent }
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async refundParticipant({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const refundPercent = payload.refundPercent
      const response = await this.$axios.post(
        ENDPOINT_PARTICIPANT_REFUND.replace(
          ':participantId',
          payload.participantId
        ),
        { refundPercent }
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async confirmPaymentParticipant({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_PARTICIPANT_CONFIRM_PAYMENT.replace(
          ':participantId',
          payload.participantId
        ),
        { amount: payload.amount, paymentMethod: payload.paymentMethod }
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
